// Use this along with onClick handlers on <div>
export const safeKeyPress = (event, callback = () => {}) => {
  const isEnter = event.which === 13 || event.keyCode === 13;
  const isSpace = event.which === 32 || event.keyCode === 32;

  if (!isEnter && !isSpace) return; // They did not press Enter or Spacebar

  callback(); // do the thing
};
